import { createContext, useContext } from "react"
import useLocalstorage from "../hooks/useLocalstorage"

const CartContext = createContext({})

export default function useCartContext() {
  return useContext(CartContext)
}

export function CartContextProvider({ children }) {
  const [cartItems, setCartItems] = useLocalstorage("dallol-cart-items", [])

  const cartQuantity = cartItems.reduce((total, item) => {
    return item.quantity + total
  }, 0)

  const increaseCartQuantity = (id) => {
    if (!id) return
    setCartItems((prevItems) => {
      const itemExists = prevItems.find((item) => item.id === id)
      if (itemExists == null) {
        return [...prevItems, { id, quantity: 1 }]
      } else {
        return prevItems.map((item) => {
          if (item.id === id) return { ...item, quantity: item.quantity + 1 }
          return item
        })
      }
    })
  }

  const decreaseCartQuantity = (id) => {
    if (!id) return
    setCartItems((prevItems) => {
      const itemExists = prevItems.find((item) => item.id === id)
      if (!itemExists) return prevItems
      if (itemExists.quantity - 1 <= 0) {
        return prevItems.filter((item) => item.id !== id)
      } else {
        return prevItems.map((item) => {
          if (item.id === id) return { ...item, quantity: item.quantity - 1 }
          return item
        })
      }
    })
  }

  const removeCartItem = (id) => {
    setCartItems((prevItems) => {
      return prevItems.filter((item) => item.id !== id)
    })
  }

  return (
    <CartContext.Provider
      value={{
        cartItems,
        increaseCartQuantity,
        decreaseCartQuantity,
        removeCartItem,
        cartQuantity,
      }}
    >
      {children}
    </CartContext.Provider>
  )
}
